import { type ReactNode } from 'react'
import { motion, useReducedMotion } from 'framer-motion'
import { cn } from '@/utils/cn'
import { getDashboardVariants } from './dashboardMotion'

interface DashboardMotionRootProps {
  children: ReactNode
  className?: string
}

/** Container com stagger para blocos do dashboard (toolbar, abas, seções). */
export function DashboardMotionRoot({ children, className }: DashboardMotionRootProps) {
  const reduced = useReducedMotion()
  const v = getDashboardVariants(reduced)

  return (
    <motion.div
      variants={v.container}
      initial='hidden'
      animate='show'
      className={className}
    >
      {children}
    </motion.div>
  )
}

export function DashboardMotionItem({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  const reduced = useReducedMotion()
  const v = getDashboardVariants(reduced)

  return (
    <motion.div variants={v.item} className={className}>
      {children}
    </motion.div>
  )
}

/** Stagger interno do conteúdo de cada aba. */
export function DashboardTabMotion({
  children,
  className,
  motionKey,
}: {
  children: ReactNode
  className?: string
  motionKey: string
}) {
  const reduced = useReducedMotion()
  const v = getDashboardVariants(reduced)

  return (
    <motion.div
      key={motionKey}
      variants={v.tab}
      initial='hidden'
      animate='show'
      exit='exit'
      className={className}
    >
      {children}
    </motion.div>
  )
}

export function DashboardTabSection({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  const reduced = useReducedMotion()
  const v = getDashboardVariants(reduced)

  return (
    <motion.div variants={v.section} className={cn(className)}>
      {children}
    </motion.div>
  )
}
